import { render, staticRenderFns } from "./displayAdvertising.vue?vue&type=template&id=a530eade&scoped=true"
import script from "./displayAdvertising.vue?vue&type=script&lang=js"
export * from "./displayAdvertising.vue?vue&type=script&lang=js"
import style0 from "./displayAdvertising.vue?vue&type=style&index=0&id=a530eade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530eade",
  null
  
)

export default component.exports